import styled from 'styled-components'

export const StyledGroundingWithVIN = styled.div`
  .spinner-row {
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .form-control:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
  .search-option-scan-btn {
    min-width: fit-content;
    background-color: ${({ theme }) => {
      return theme.carousel.buttonColor
    }};
    border: 1px solid lightgray;
    margin: 0 0 0 -1px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => {
      return theme.carousel.buttonTextColor
    }};

    * {
      cursor: pointer;
    }

    svg {
      margin: 0 5px;
      fill: ${({ theme }) => {
        return theme.carousel.buttonTextColor
      }};
      height: 1.8rem;
      width: 1.8rem;
      flex-shrink: 0;
    }

    label {
      line-height: normal;
      margin: 0;
      color: ${({ theme }) => {
        return theme.carousel.buttonTextColor
      }};
    }

    &:hover {
      background-color: black;
      label {
        color: white;
      }
      svg {
        fill: white;
      }
    }
  }
`
